<template>
	<div class="px-3">
		<div class="d-flex align-items-center flex-wrap">
			<div class="flex-grow-1">
				<h4 class="item-title">{{bookingPass.title}}</h4>
				<div v-if="showPrice" class="d-inline-block">
					{{ getExchangedAmount(bookingPass.price) }}
				</div>
			</div>
			<div class="flex-grow-0 flex-shrink-0">
				<div class="d-flex align-items-center">
					<span v-if="hasItemSoldOut">{{$t('booking_passes.sold_out')}}</span>
				</div>
			</div>
		</div>
		<div class="pt-2 pb-2 item-description" v-html="bookingPass.description.nl2brIfNotHTML()"></div>
		<div v-if="bookingPass.presets?.length" class="my-3">
			<div class="preset-section-title text-muted">{{ $t('booking_passes.booking_to_activate_when_purchased') }}</div>
			<table class="preset-table">
				<tr v-for="preset in bookingPass.presets" :key="preset.id">
					<td>{{formatPresetDate(preset)}}</td>
					<td>
						<div>{{presetServiceName(preset)}}</div>
						<div>{{presetMemberName(preset)}}</div>
					</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { getExchangedAmount } from '../../bu/CurrencyUtils';

export default {
	props: {
		context: { required: true, type: Object },
		provider: { required: true, type: Object },
		bookingPass: { required: true, type: Object },
		showPrice: { type: Boolean, default: true },
	},
	computed: {
		...mapGetters({
			currency: 'currencies/currency',
			currencyRateMap: 'currencies/currencyRateMap',
			currencyOptions: 'currencies/currencyOptions',
		}),
		hasItemSoldOut() {
			return this.bookingPass.total_issueable_count - this.bookingPass.total_issued_count <= 0;
		},
	},
	data() {
		return {};
	},
	methods: {
		formatPresetDate(preset) {
			return moment.tz(preset.start_datetime, 'GMT').tz(this.provider.timezone).format('YYYY-MM-DD A h:mm');
		},
		presetServiceName(preset) {
			const service = this.provider.services.find((service) => service.id === preset.service_id);
			return service.title;
		},
		presetMemberName(preset) {
			const member = this.provider.members.find((member) => member.id === preset.member_user_id);
			return member.name;
		},
		getExchangedAmount(amount) {
			return getExchangedAmount({
				rateMap: this.currencyRateMap,
				amount,
				from: this.provider.currency || 'TWD',
				to: this.currency,
				currencyOptions: this.currencyOptions,
			});
		},
	}
}
</script>

<style scoped lang="scss">
.item-title {
	font-size: 1.3rem;
	margin: 1rem 0 0.8rem;
	font-weight: bold;
}

.item-description {
	font-size: 0.9rem;
	width: 100%;

	/deep/ img {
		max-width: 100%;
	}
	
	/deep/ p {
		margin: 0;
	}
}

.preset-table {
	width: 100%;
	tr {
		border-bottom: 1px solid #ddd;
	}
	tr:last-child {
		border-bottom: none;
	}
	td {
		text-align: left;
		padding: 0;
		font-size: 0.9rem;
	}
	td:nth-child(1) {
		min-width: 125px;
	}
	td:nth-child(2) {
		padding: 8px 16px 4px;
		width: 100%;
	}
}
</style>
